import {
  ATBeaconAccordion,
  ATBeaconAccordionItem,
} from 'components/common/beacon/beaconRegistration';
import React from 'react';

interface AccordionItem {
  title: string;
  panel: string | string[];
}

interface AccordionProps {
  items: AccordionItem[];
}

const Accordion: React.FC<AccordionProps> = (props) => {
  const { items } = props;

  if (!items || items.length === 0) {
    return null;
  }

  return (
    <ATBeaconAccordion data-testid="accordion-menu">
      {items.map((item, index) => {
        return (
          <ATBeaconAccordionItem key={index}>
            <span className="b-font-weight-bold" slot="title">
              {item.title}
            </span>
            <div slot="panel">
              {Array.isArray(item.panel) ? (
                item.panel.map((paragraph, idx) => <p key={idx}>{paragraph}</p>)
              ) : (
                <p>{item.panel}</p>
              )}
            </div>
          </ATBeaconAccordionItem>
        );
      })}
    </ATBeaconAccordion>
  );
};

export default Accordion;
